import { render, staticRenderFns } from "./BusNewAccount.vue?vue&type=template&id=4607dc4f&scoped=true"
import script from "./BusNewAccount.vue?vue&type=script&lang=js"
export * from "./BusNewAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4607dc4f",
  null
  
)

export default component.exports